/*jslint es6:true*/
import commonutils from '../utils/common';
import analytics from '../utils/analytics';
//import { faBorderStyle } from '@fortawesome/free-solid-svg-icons';
export default class Modal {
  constructor(el) {
    this.el = el;
    this.modalid = this.el.dataset.open;
    this.modal = this.modalid
      ? document.getElementById(this.modalid)
        ? document.getElementById(this.modalid)
        : document.querySelector(`[data-modal="${this.modalid}"]`)
      : false;
    this.modalwrapperid = `${this.modalid}-wrapper`;
    this.initialize();
  }

  initialize() {
    let wrapper = document.createElement('div');
    wrapper.id = this.modalwrapperid;
    wrapper.classList.add('modal-wrapper');
    wrapper.style.display = 'none'; //hide by default
    commonutils.wrap(this.modal, wrapper);
    this.modalwrapper = document.getElementById(this.modalwrapperid);
    this.modal.insertAdjacentHTML(
      'afterbegin',
      '<button class="close-popup close-button">close</button>'
    );
    document.body.insertAdjacentElement('beforeend', wrapper);
    this.clickhandler();
  }

  clickhandler() {
    this.el.addEventListener('click', (e) => {
      e.preventDefault();
      this.modalwrapper.style.display = 'flex';
      this.modal.classList.add('open');
      if (this.modal.dataset.framesource) {
        try {
          this.modal.querySelector('iframe').src =
            this.modal.dataset.framesource;
        } catch (e) {
          console.log(e);
        }
      }
      analytics.logevent('modal', 'open', this.el.textContent);
      const event = document.createEvent('HTMLEvents');
      event.initEvent('resize', true, false);
      this.el.dispatchEvent(event);
    });
    [...this.modalwrapper.querySelectorAll('.close-button')].forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        this.modalwrapper.style.display = 'none';
      });
    });
    this.modalwrapper.addEventListener('click', (e) => {
      e.preventDefault();
      if (e.target === this.modalwrapper) {
        this.modalwrapper.style.display = 'none';
      }
    });
  }
}
